import React, { useState } from 'react';

import { AttentionMessage } from '@eika/attention-message';
import { Link, LinkType } from '@eika/link';

import { Header } from '../../components/header/header';
import { RadioButtons } from '../../components/radio-buttons/radio-buttons';
import SporreskjemaButton from '../../components/sporreskjema-button/sporreskjema-button';
import { StepNavigation } from '../../components/step-navigation/step-navigation';
import { SvgCardType } from '../../components/svg-card/svg-card-types';
import { useBankregnr, useConfig } from '../../config';
import { useWindowScrollTop } from '../../sporsmalsflyt/hooks';
import { toOptions } from '../../sporsmalsflyt/radio/radio';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { SideType } from '../../utils/piwik-utils';

import './dyr.scss';

export enum Dyr {
    Hund = 'hunden',
    Katt = 'katten',
    Hest = 'hesten',
}

interface Props {
    title: string;
    radioButtonsLabel?: string;
    alternativer: RadioAlternativ[];
    dyr: Dyr;
    onNext: (svarId: string) => void;
    navigateToParent: () => void;
    svgCardType?: SvgCardType;
}

export const GruppeLandingssideDyr = ({
    title,
    radioButtonsLabel,
    alternativer,
    dyr,
    onNext,
    navigateToParent,
    svgCardType,
}: Props) => {
    const [selectedOption, setSelectedOption] = useState<string | undefined>(undefined);
    const { links } = useConfig();
    const windowScollTop = useWindowScrollTop();
    const bankregnr = useBankregnr();
    const kategoriId = Object.keys(Dyr)[Object.values(Dyr).indexOf(dyr)].toLowerCase();

    const getFirstVetHref = (): string => (dyr === Dyr.Katt ? links.kattfirstvet.url : links.hundfirstvet.url);

    return (
        <>
            <form className="meld-skade-form">
                <Header svgCardType={svgCardType} title={title} subtitle="Skademelding" />
                <RadioButtons
                    name=""
                    label={radioButtonsLabel}
                    options={toOptions(alternativer, kategoriId)}
                    selectedOption={selectedOption}
                    onChange={setSelectedOption}
                    focusOnMount
                />
                <div className="videokonsultasjon-veterinar container__standard-width">
                    <AttentionMessage
                        id="attention-veterinar"
                        text={
                            <>
                                <h4>Videokonsultasjon fra veterinær</h4>
                                <p>
                                    Har du forsikret {dyr.valueOf()} din hos Fremtind Forsikring kan du få gratis
                                    videokonsultasjon hos FirstVet.
                                </p>
                            </>
                        }
                        type="warning"
                        clickableItem={
                            <Link href={getFirstVetHref()} linkType={LinkType.BUTTON_STANDARD_NEGATIVE}>
                                Les mer om FirstVet
                            </Link>
                        }
                    />
                </div>
                <StepNavigation
                    bankregnr={bankregnr}
                    next={{
                        onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                            e.preventDefault();
                            onNext(selectedOption);
                        },
                        disabled: !selectedOption,
                    }}
                    prev={{
                        onClick: () => {
                            windowScollTop();
                            navigateToParent();
                        },
                    }}
                    sideDetail={{ type: SideType.Kategoriside, kategoriId }}
                />
            </form>
            <SporreskjemaButton />
        </>
    );
};
